// extracted by mini-css-extract-plugin
export default {"play-icon":"PlayIcon_play-icon__asPr3","play-icon-circle":"PlayIcon_play-icon-circle__fwack","play":"PlayIcon_play__umHXm"};